var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 670.18 732.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-19,.cls-20,.cls-21,.cls-26,.cls-29,.cls-32,.cls-40{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#c20202;}.cls-4{fill:#8c3f2a;}.cls-5{fill:#ffc700;}.cls-6{fill:#de7756;}.cls-7{fill:#7a3636;}.cls-8{fill:#fff;}.cls-9{fill:#feb187;}.cls-10{fill:#fffff3;}.cls-11{fill:#392d3b;}.cls-12{fill:#4b4051;}.cls-13{fill:#c0a2ac;}.cls-14{fill:#ef4d41;}.cls-15{fill:#8d3b25;}.cls-16{fill:#6b281b;}.cls-17{opacity:0.52;}.cls-18{fill:#ef7959;}.cls-19{stroke:#c6476e;}.cls-19,.cls-20,.cls-21,.cls-26,.cls-29,.cls-32,.cls-40{stroke-miterlimit:10;}.cls-19,.cls-20,.cls-21{stroke-width:7.42px;}.cls-20{stroke:#ffb600;}.cls-21{stroke:#ff9100;}.cls-22{fill:#d8c2c0;}.cls-23{fill:#9b8080;}.cls-24{fill:#ba9e9d;}.cls-25{clip-path:url(#clip-path);}.cls-26{stroke:#91bfa7;stroke-width:1.31px;}.cls-27{fill:#7fa59e;}.cls-28{fill:#ff7150;}.cls-29{stroke:#857c99;stroke-width:5.23px;}.cls-30{fill:#ff4d40;}.cls-31{fill:#a9d100;}.cls-32{stroke:#ed201b;stroke-width:2.62px;}.cls-33{fill:#7a2727;}.cls-34{fill:#a30000;opacity:0.44;}.cls-35{fill:#acb3ce;}.cls-36{fill:#959ab5;}.cls-37{fill:#888da8;}.cls-38{opacity:0.59;mix-blend-mode:multiply;}.cls-39{fill:#9c9caf;}.cls-40{stroke:#ad5235;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 12.56)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.9,239.53a38.66,38.66,0,0,1-38.66,38.66H131.6A38.65,38.65,0,0,1,93,239.53V40.16A38.65,38.65,0,0,1,131.6,1.5H541A35.92,35.92,0,0,1,576.9,37.41Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 699.23,
    width: 670.18,
    height: 32.81,
    rx: 10.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.72,656.5l-14-92.91a42.8,42.8,0,0,1,42.33-49.19h56.54l26.78,143Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.36,655.45l-14-92.91a42.8,42.8,0,0,1,42.33-49.19h56.54l26.78,143Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.73,655.33l-94.39-.79-17.26-.15-14-92.9a42.77,42.77,0,0,1,42.33-49.19H204Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.73,655.33l-94.39-.79c-.5-30.81-5.35-99.35-10-136.71a42.54,42.54,0,0,1,21.08-5.53H204Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 665.65,
    width: 670.18,
    height: 52.22,
    rx: 10.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441.84,661.91c4.27,0,4.3-6.59,0-6.61l-69.8-.35.42,6.61Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M670.18,680.8H248.78l-5.63-27.95H659.53a10.61,10.61,0,0,1,10.61,10.59Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.22,678s-74.71-5.52-86.79-10c-2.43-.9-4.05-5.78-6.66-14.92h91Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 237.5,
    y: 666.9,
    width: 113.78,
    height: 33.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M439.91,661.13l-67.86-.65.12-24.15,29.32,3.47,28.86-7.44a2.21,2.21,0,0,1,1.44.32l20.28,13a2.14,2.14,0,0,1,.86,1.06L458.24,661Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.46,642.82l19.21-4.07,4.9.59a31.65,31.65,0,0,0-1,11.74l3.4.9s4.29,9.74,13.25,9.15h-42l.92-16.91Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M416.44,661.73c-2.4,0-2.37-6.63,0-6.61l29.29.14c1,0,1.87,1.54,1.83,3.39v.07c0,1.76-.86,3.16-1.85,3.16Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M447.15,660.82l-31.58-.16c-2.63,0-2.6-6.63,0-6.61l31.58.16c2.63,0,2.59,6.62,0,6.61Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M422.76,659.07c-2.8-3.83-8.32-3.42-9.56-7.31a37.84,37.84,0,0,0,11.67-2l10.47,10.68Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 368.08,
    y: 637.27,
    width: 36.02,
    height: 15.1,
    transform: "translate(-285.47 994.83) rotate(-85.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M386.59,623.16l-69.34-7L306.94,507.81a25.77,25.77,0,0,0-10.62-14.46c-12.05-7.93-32.58-21.25-44.41-25.39-23.24-8.14-32.67,5.25-84.25,26.06l93.6,171.38h23.58l3.54-75.68-5.44-6.16.26,77.82,100.59,5.83Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M287.22,614.83l.31,50.57h-5.25S246.4,459.73,251.63,461.32c25.49,7.73,50.5,37.28,50.5,37.28S310.88,532.61,287.22,614.83Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M270.69,654.27H142.32c6.61-98.2,7.48-155.67,36.4-168.76C185.38,482.5,270.69,654.27,270.69,654.27Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M238.49,461.32s-64.78,14.24-73.91,36.51c-13.49,32.92-7.81,159.49,4,163s82.51,10.87,82.51,10.87l1.41-39.26-46.46-13.75s2.09-74.59-5.61-117.85Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M246.42,461.32s-23-1.32-47.84,16.88c0,0-11.43,55,44,161.4-9.49-126.92-36.72-154.74-27.79-163.15C222.37,469.33,246.42,461.32,246.42,461.32Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M249.26,461.32s-23-1.32-47.84,16.88c0,0-9.84,47.37,33.06,139.22l2.17,19.67s10.84,1,10.51,0c-9.49-126.93-38.43-152.23-29.51-160.64C225.21,469.33,249.26,461.32,249.26,461.32Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M208.15,515.09l33,121,4.5-.58s.22-96.74-22.87-158.94Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216,488s27.82,122.7,28.46,179.27l26.39.14c26.72-127.7,6.34-176.59,6.34-176.59S264.19,461.8,216,488Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M234.94,473.22s-.63,11.83,20.59,17.63h21.7c5,17.64-5.84,28.37-5.84,28.37L255.77,498.6,243.09,524s-28.26-10.86-26.53-41.55Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M262.37,506.67l-5.46,9.91c-1.57,2.85-5.33,2.7-7.56-.31l-7.72-10.44c-2.08-2.81-1.76-6.72.67-8.2l6.14-3.77a4.16,4.16,0,0,1,4.39.18l7,4.3C262.65,500,263.84,504,262.37,506.67Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M270.37,643.83l-11.19,9.44a4.46,4.46,0,0,1-5.28.1l-11.69-9a2.4,2.4,0,0,1-1-2l7.59-126.26c.09-1.44,1.64-2.6,3.55-2.63l1,0c1.91,0,3.53,1,3.69,2.49l14.3,125.81A2.37,2.37,0,0,1,270.37,643.83Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M264.79,504.65l-4.68,9.61c-1.34,2.76-4.61,2.65-6.56-.24l-6.78-10c-1.83-2.69-1.58-6.48.52-7.93l5.31-3.68a3.3,3.3,0,0,1,3.81.14l6.15,4.09A6.79,6.79,0,0,1,264.79,504.65Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.17,461.42s-1.86,23.63,19.36,29.43l-14.06,25.56s-33.5-11.85-23.16-40.28C222.52,464.57,236.17,461.42,236.17,461.42Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M255.53,490.85l17,20.45s13.32-20.82-8-42.53Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M272.7,637l-9.66,9.2a3.57,3.57,0,0,1-4.59.15l-10.21-8.59a2.37,2.37,0,0,1-.91-2l5.71-122a3,3,0,0,1,3.07-2.57l.85,0a3,3,0,0,1,3.22,2.38L273.49,635A2.42,2.42,0,0,1,272.7,637Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.28,376.11c2.88,34-49.77,71.14-76.38,71.09h-8.16c-28.81,0-33.41-46.78-33.41-73.32v-1c1-27.23,24.59-49,52.15-48.07h21.87c28.81,0,43.93,24.72,43.93,51.27Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M284.84,442.71c-4.06,8.13-9.12,17.56-13.95,26.69-3,5.64-6.48,11.69-9,16.7-4.31,8.62-14.52,8.09-22.42,3.46-8.33-4.88-11.54-12.5-8.05-20.7.16-.38.34-.75.53-1.14,6.56-13.14,15.76-29.72,22.32-42.86,4.31-8.62,15.63-8.79,23.53-4.16C286.54,425.81,289.14,434.08,284.84,442.71Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M284.84,442.71c-4.06,8.13-9.12,17.56-13.95,26.69-7.21,5.21-32.36,4.26-39.45-.54.16-.38.34-.75.53-1.14,6.56-13.14,15.76-29.72,22.32-42.86,4.31-8.62,15.63-8.79,23.53-4.16C286.54,425.81,289.14,434.08,284.84,442.71Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M313.65,424.62A40.65,40.65,0,0,1,273,465.29h-.82a40.66,40.66,0,0,1-40.68-40.65V383.48a40.67,40.67,0,0,1,40.65-40.67H273a40.66,40.66,0,0,1,40.67,40.65Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.23,417c.79,6.91-.45,12.87-7.36,13.66h0c-14.67,1.36-17.91-13.07-18.69-20a12.57,12.57,0,0,1,11.07-13.93h0a12.58,12.58,0,0,1,13.93,11.07Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.12,419.58c0,32-27.66,50.61-50.12,50.61h-.82c-22.46,0-31.21-18.2-31.21-40.66V388.37a40.67,40.67,0,0,1,40.67-40.66h.82a40.67,40.67,0,0,1,40.66,40.66Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 240.02,
    y: 355.37,
    width: 82.15,
    height: 122.48,
    rx: 40.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.57,398.74v13.17c.12,1,3.54,1.39,4.22.64,2.16-2.37,5.75-14.4,7.61-28.59,0,0,59.21,5.43,67.63-21.86,8.06-26.09-29.67-47.5-53.37-24.9C218.73,345.1,231.57,398.74,231.57,398.74Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M258.94,398.66h18.18c2.71,0,2.72-4.21,0-4.21H258.94c-2.71,0-2.71,4.21,0,4.21Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M297.73,398.66h15c2.71,0,2.72-4.21,0-4.21h-15c-2.71,0-2.71,4.21,0,4.21Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M276.51,407.26c0,3.62-3.31,6.56-7.39,6.56s-7.39-2.94-7.39-6.56,3.31-3.74,7.39-3.74S276.51,403.64,276.51,407.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M275.43,409a4.12,4.12,0,1,1-4.12-4.12A4.12,4.12,0,0,1,275.43,409Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M269.26,407.58a1.58,1.58,0,1,1-1.58-1.57A1.58,1.58,0,0,1,269.26,407.58Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M310.44,407.26c0,3.62-3.31,6.56-7.39,6.56s-7.38-2.94-7.38-6.56,3.3-3.74,7.38-3.74S310.44,403.64,310.44,407.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M309.37,409a4.13,4.13,0,1,1-4.12-4.12A4.13,4.13,0,0,1,309.37,409Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M293.59,421.68c-.33,5.91-12.32,5.89-12.65,0-.1-1.8-2.9-1.81-2.8,0,.53,9.62,17.72,9.62,18.26,0,.1-1.81-2.71-1.8-2.81,0Z",
    transform: "translate(0 12.56)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M280.85,445.76h11.84a1.88,1.88,0,0,0,0-3.75H280.85a1.88,1.88,0,0,0,0,3.75Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.57,640s19.24-11.74,22.45-11.3,12.42,8.48,12.42,8.48,8-.24,9.8,1.56,2.34,6.29-8.33,8S275.57,640,275.57,640Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 301.67,
    y1: 626.5,
    x2: 300.17,
    y2: 620.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 311.91,
    y1: 668.61,
    x2: 301.67,
    y2: 626.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 311.83,
    y1: 668.29,
    x2: 306.33,
    y2: 645.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.69,672.61c4.19,0,6.16-7.51,1.08-7.51H240.71l.46,4.15,42.89.76C301.45,671.58,312.64,672.61,319.69,672.61Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M331.22,640.5h-30.3l-21.84-1.35a6,6,0,0,0-4.19,1.35h-5.77c-4.2,0-5,5.46-2.35,7.51-3.1,1.14-3,6.76.18,7.71-4.32.32-4.24,8.17.26,8.17h1.23c-2,1.87-1.39,6.64,2,6.64a54.4,54.4,0,0,0,13.11-2c14.87,1.06,26.84,2,37.24,2,3.38,0,4-4.8,2-6.66,4.06-.21,4.32-7,.79-8,3.37-.24,4.06-5,2.06-7.08h5.64C336.38,648.77,336.38,640.5,331.22,640.5Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "287.65 680.01 249.26 682 249.26 653.13 287.65 653.13 287.65 680.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "249.26 668.94 276.56 682.36 249.26 682.36 249.26 668.94 249.26 668.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M281.56,671.31l-15.1.34-.8-35.35,15.1-.35C275.31,661.67,281.56,671.31,281.56,671.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M182.26,662.88c11.83,3.46,89.68,11,89.68,11s-9-19.6,1.35-40.65l-64.08-12.48Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 367.55,
    y: 670.65,
    width: 188.09,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 474.86,
    y: 670.65,
    width: 123.93,
    height: 15.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "508.04 529.88 475.08 670.65 463.64 670.65 496.6 529.88 508.04 529.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "599.2 670.65 474.75 670.65 508.04 529.88 632.49 529.88 599.2 670.65"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 92.07,
    y: 50.65,
    width: 485.28,
    height: 241.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 92.07,
    y: 49.27,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 172.95,
    y: 49.27,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 253.83,
    y: 49.27,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 334.71,
    y: 49.27,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 415.59,
    y: 49.27,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 496.47,
    y: 49.27,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 92.07,
    y: 130.15,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 172.95,
    y: 130.15,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 253.83,
    y: 130.15,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 334.71,
    y: 130.15,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 415.59,
    y: 130.15,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 496.47,
    y: 130.15,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 92.07,
    y: 211.03,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 172.95,
    y: 211.03,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 253.83,
    y: 211.03,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 334.71,
    y: 211.03,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 415.59,
    y: 211.03,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 496.47,
    y: 211.03,
    width: 80.88,
    height: 80.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M158.8,57.83v4.72c0,2.94-2.27,4.63-5.06,4.63s-5-1.69-5-4.63V57.83c0-2.94,2.29-4.64,5-4.64S158.8,54.89,158.8,57.83Zm-3.25,4.64V57.89a1.61,1.61,0,0,0-1.81-1.62A1.58,1.58,0,0,0,152,57.89v4.58a1.59,1.59,0,0,0,1.75,1.65A1.62,1.62,0,0,0,155.55,62.47Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M160.91,56.23V53.44h5.17V64.1h2v2.81h-7.39V64.1h2V56.23Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M238.2,57.83v4.72c0,2.94-2.27,4.63-5.06,4.63s-5-1.69-5-4.63V57.83c0-2.94,2.29-4.64,5-4.64S238.2,54.89,238.2,57.83ZM235,62.47V57.89a1.61,1.61,0,0,0-1.81-1.62,1.58,1.58,0,0,0-1.75,1.62v4.58a1.59,1.59,0,0,0,1.75,1.65A1.62,1.62,0,0,0,235,62.47Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M244.76,56.31a1.19,1.19,0,0,0-1.33,1.31H240.5a4.09,4.09,0,0,1,4.32-4.39c3.86-.09,5.56,3.73,3.55,6.83l-2.71,3.77h4v3.08H240.2v-.52l5.06-7.4C245.93,58.08,246.45,56.31,244.76,56.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M318.92,57.83v4.72c0,2.94-2.27,4.63-5.06,4.63s-5-1.69-5-4.63V57.83c0-2.94,2.29-4.64,5-4.64S318.92,54.89,318.92,57.83Zm-3.25,4.64V57.89a1.61,1.61,0,0,0-1.81-1.62,1.58,1.58,0,0,0-1.75,1.62v4.58a1.59,1.59,0,0,0,1.75,1.65A1.62,1.62,0,0,0,315.67,62.47Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M324.24,62.8c0,.88.6,1.32,1.52,1.32a1.48,1.48,0,0,0,1.48-1.61c0-1.95-1.94-1.87-3.4-1.81v-.46l1.79-3.74h-3.89V53.44h8.56v.5l-2.48,4.54c2.14.54,2.75,2.28,2.75,4a4.56,4.56,0,0,1-4.73,4.69,4.77,4.77,0,0,1-2.41-.57,4.32,4.32,0,0,1-2.21-3.81Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M399.14,57.83v4.72c0,2.94-2.27,4.63-5.06,4.63s-5-1.69-5-4.63V57.83c0-2.94,2.29-4.64,5-4.64S399.14,54.89,399.14,57.83Zm-3.25,4.64V57.89a1.61,1.61,0,0,0-1.81-1.62,1.58,1.58,0,0,0-1.75,1.62v4.58a1.59,1.59,0,0,0,1.75,1.65A1.61,1.61,0,0,0,395.89,62.47Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M410.12,66.91h-3.2V64.35h-5.86v-1.5l5.36-9.41h3.7v8.1h1.15v2.81h-1.15Zm-5.22-5.37h2.16v-2l.25-2.05h0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M479.9,57.83v4.72c0,2.94-2.27,4.63-5.06,4.63s-5-1.69-5-4.63V57.83c0-2.94,2.29-4.64,5-4.64S479.9,54.89,479.9,57.83Zm-3.25,4.64V57.89a1.61,1.61,0,0,0-1.81-1.62,1.58,1.58,0,0,0-1.75,1.62v4.58a1.59,1.59,0,0,0,1.75,1.65A1.61,1.61,0,0,0,476.65,62.47Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M485.51,58c3.14-.19,6.18.45,6.2,4.45A4.56,4.56,0,0,1,487,67.18a4.31,4.31,0,0,1-4.54-4.38h3a1.31,1.31,0,0,0,1.5,1.34c.94,0,1.52-.56,1.54-1.65A1.47,1.47,0,0,0,487.22,61a16.81,16.81,0,0,0-4.56-.09V53.44h8.39v2.93h-5.54Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M560.37,57.83v4.72c0,2.94-2.27,4.63-5.06,4.63s-5-1.69-5-4.63V57.83c0-2.94,2.29-4.64,5-4.64S560.37,54.89,560.37,57.83Zm-3.25,4.64V57.89a1.61,1.61,0,0,0-1.81-1.62,1.58,1.58,0,0,0-1.75,1.62v4.58a1.59,1.59,0,0,0,1.75,1.65A1.61,1.61,0,0,0,557.12,62.47Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M571.08,53.33l-2.84,4.85A4.08,4.08,0,0,1,573,62.49c0,3.15-2.27,4.63-5.14,4.63s-5.17-1.48-5.17-4.63a4.73,4.73,0,0,1,.71-2.64l3.88-6.52Zm-1.57,9.16a1.58,1.58,0,0,0-1.68-1.7,1.62,1.62,0,0,0-1.73,1.7,1.65,1.65,0,0,0,1.73,1.71A1.59,1.59,0,0,0,569.51,62.49Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M155.4,126.35v4.71c0,2.94-2.27,4.64-5.06,4.64s-5-1.7-5-4.64v-4.71c0-2.95,2.29-4.64,5-4.64S155.4,123.4,155.4,126.35ZM152.15,131V126.4a1.61,1.61,0,0,0-1.81-1.61,1.58,1.58,0,0,0-1.75,1.61V131a1.59,1.59,0,0,0,1.75,1.66A1.62,1.62,0,0,0,152.15,131Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M162.75,135.66c-5.49,0-6.62-5.6-3.41-7.91-2-2.13-.79-6,3.41-6s5.35,3.92,3.4,6C169.33,130.1,168.19,135.66,162.75,135.66Zm0-6.25a1.67,1.67,0,1,0,0,3.34A1.67,1.67,0,1,0,162.75,129.41Zm0-5a1.09,1.09,0,1,0,0,2.16A1.09,1.09,0,1,0,162.75,124.44Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M237.69,126.35v4.71c0,2.94-2.27,4.64-5.06,4.64s-5-1.7-5-4.64v-4.71c0-2.95,2.29-4.64,5-4.64S237.69,123.4,237.69,126.35ZM234.44,131V126.4a1.61,1.61,0,0,0-1.81-1.61,1.58,1.58,0,0,0-1.75,1.61V131a1.59,1.59,0,0,0,1.75,1.66A1.62,1.62,0,0,0,234.44,131Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M241.71,135.56l2.86-4.86a4.16,4.16,0,0,1-4.69-4.31c0-3.18,2.15-4.62,5.12-4.62s5.17,1.44,5.17,4.62a4.62,4.62,0,0,1-.71,2.65l-3.92,6.52Zm1.59-9.17a1.62,1.62,0,0,0,1.7,1.69,1.54,1.54,0,0,0,1.69-1.69,1.6,1.6,0,0,0-1.69-1.68A1.63,1.63,0,0,0,243.3,126.39Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M309.75,124.75V122h5.18v10.66h2v2.81h-7.39v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M328.64,126.35v4.71c0,2.95-2.27,4.64-5.06,4.64s-5-1.69-5-4.64v-4.71c0-2.95,2.29-4.64,5-4.64S328.64,123.4,328.64,126.35ZM325.39,131V126.4a1.61,1.61,0,0,0-1.81-1.61,1.58,1.58,0,0,0-1.75,1.61V131a1.59,1.59,0,0,0,1.75,1.66A1.62,1.62,0,0,0,325.39,131Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M393.69,124.5v-2.79h5.18v10.66h2v2.81h-7.39v-2.81h2V124.5Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M402.67,124.5v-2.79h5.18v10.66h2v2.81H402.5v-2.81h2V124.5Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M474.15,124.71v-2.79h5.17v10.66h2v2.81H474v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M487.11,124.79a1.18,1.18,0,0,0-1.32,1.31h-2.93a4.08,4.08,0,0,1,4.31-4.39c3.87-.1,5.56,3.73,3.56,6.83L488,132.31h4v3.08h-9.47v-.52l5.06-7.41C488.29,126.56,488.81,124.79,487.11,124.79Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M554.89,124.5v-2.79h5.18v10.66h2v2.81h-7.39v-2.81h2V124.5Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M566.33,131.06c0,.89.6,1.33,1.52,1.33a1.49,1.49,0,0,0,1.49-1.62c0-1.94-2-1.86-3.41-1.81v-.46l1.79-3.73h-3.89v-3.06h8.57v.5l-2.49,4.54c2.14.54,2.76,2.27,2.76,4a4.84,4.84,0,0,1-7.14,4.12,4.32,4.32,0,0,1-2.22-3.81Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M149.59,205.38v-2.79h5.18v10.66h2v2.81h-7.39v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M161.61,207.19c3.14-.19,6.18.44,6.2,4.44a4.57,4.57,0,0,1-4.74,4.7,4.32,4.32,0,0,1-4.54-4.39h3a1.32,1.32,0,0,0,1.5,1.35c.94,0,1.52-.56,1.54-1.66a1.45,1.45,0,0,0-1.22-1.44,16.85,16.85,0,0,0-4.56-.1v-7.5h8.39v2.92h-5.54Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M231.54,205.49V202.7h5.17v10.66h2v2.81h-7.39v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M248.37,202.59l-2.85,4.85a4.08,4.08,0,0,1,4.74,4.31c0,3.15-2.28,4.64-5.14,4.64s-5.18-1.49-5.18-4.64a4.73,4.73,0,0,1,.71-2.64l3.89-6.52Zm-1.58,9.16a1.57,1.57,0,0,0-1.67-1.69,1.6,1.6,0,0,0-1.73,1.69,1.65,1.65,0,0,0,1.73,1.71A1.58,1.58,0,0,0,246.79,211.75Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M310.63,205.38v-2.79h5.18v10.66h2v2.81h-7.39v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M328.5,203.11l-5.44,12.95h-3.54L324,205.67h-5.29v-3.08h9.83Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M392.74,205.61v-2.79h5.18v10.66h2v2.81h-7.39v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M406.36,216.52c-5.48,0-6.62-5.6-3.41-7.91-2-2.13-.79-6,3.41-6s5.35,3.92,3.41,6C412.94,211,411.81,216.52,406.36,216.52Zm0-6.25a1.67,1.67,0,1,0,0,3.34A1.67,1.67,0,1,0,406.36,210.27Zm0-5a1.09,1.09,0,1,0,0,2.16A1.09,1.09,0,1,0,406.36,205.3Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M474,205.57v-2.79h5.17v10.66h2v2.81h-7.39v-2.81h2v-7.87Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M483.65,216.39l2.87-4.87a4.16,4.16,0,0,1-4.7-4.31c0-3.18,2.16-4.62,5.12-4.62s5.18,1.44,5.18,4.62a4.63,4.63,0,0,1-.72,2.65l-3.92,6.53Zm1.6-9.18a1.61,1.61,0,0,0,1.69,1.69,1.53,1.53,0,0,0,1.69-1.69,1.6,1.6,0,0,0-1.69-1.68A1.62,1.62,0,0,0,485.25,207.21Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M557.44,205.71a1.18,1.18,0,0,0-1.33,1.3h-2.92a4.07,4.07,0,0,1,4.31-4.38c3.87-.1,5.56,3.73,3.56,6.83l-2.72,3.77h4v3.08h-9.47v-.52l5.06-7.41C558.61,207.48,559.13,205.71,557.44,205.71Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M574.5,207.23v4.71c0,2.94-2.27,4.64-5.06,4.64s-5-1.7-5-4.64v-4.71c0-2.95,2.29-4.64,5-4.64S574.5,204.28,574.5,207.23Zm-3.25,4.63v-4.58a1.61,1.61,0,0,0-1.81-1.61,1.58,1.58,0,0,0-1.75,1.61v4.58a1.59,1.59,0,0,0,1.75,1.66A1.62,1.62,0,0,0,571.25,211.86Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 141.73,
    y1: 89.71,
    x2: 160.73,
    y2: 89.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 101.84,
    y1: 89.71,
    x2: 134.02,
    y2: 89.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 113.82,
    y1: 102.57,
    x2: 103.06,
    y2: 102.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 161.96,
    y1: 102.57,
    x2: 121.54,
    y2: 102.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 284.43,
    y1: 177.71,
    x2: 265.43,
    y2: 177.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 324.33,
    y1: 177.71,
    x2: 292.15,
    y2: 177.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 298.61,
    y1: 164.85,
    x2: 309.37,
    y2: 164.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 264.21,
    y1: 164.85,
    x2: 290.89,
    y2: 164.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M321.79,182c-13.7,5.78-29,7.27-43.33,3-11.74-3.51-22.2-12-22.63-25.06-1.1-33.63,48.54-38.94,68.65-21.09,5.66,5,9.37,12.28,7.92,20-1.76,9.29-9.75,15.5-17.87,19.23-1.91.88-.25,3.69,1.65,2.82,14.19-6.52,25.51-21.74,16.59-37.14-8.33-14.38-27.61-19.47-43.14-18.17-15.13,1.26-31.21,9.28-35.85,24.76-3.86,12.87,1.57,25.89,12.77,32.94,16.43,10.33,38.8,9.19,56.11,1.9,1.91-.81,1.07-4-.87-3.16Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 462.95,
    y1: 245.04,
    x2: 481.95,
    y2: 245.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 423.05,
    y1: 245.04,
    x2: 455.23,
    y2: 245.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 435.04,
    y1: 257.9,
    x2: 424.28,
    y2: 257.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 483.17,
    y1: 257.9,
    x2: 442.75,
    y2: 257.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 460.96,
    y1: 102.57,
    x2: 428.22,
    y2: 102.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 487.11,
    y1: 102.57,
    x2: 468.67,
    y2: 102.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 460.02,
    y1: 89.71,
    x2: 485.89,
    y2: 89.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 426.99,
    y1: 89.71,
    x2: 452.3,
    y2: 89.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M105.24,64.35l55.82,44.37c1.63,1.3,4-1,2.31-2.31L107.55,62c-1.63-1.3-4,1-2.31,2.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M107,113l52.48-50.61c1.52-1.47-.79-3.78-2.31-2.32l-52.48,50.62c-1.52,1.46.79,3.77,2.31,2.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M423.53,216.68l55.82,44.37c1.63,1.3,4-1,2.31-2.31l-55.82-44.37c-1.63-1.3-4,1-2.31,2.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M425.26,265.37l52.48-50.61c1.52-1.47-.79-3.78-2.31-2.31l-52.49,50.61c-1.51,1.46.8,3.77,2.32,2.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M427.25,63.15l55.82,44.37c1.63,1.3,4-1,2.32-2.31L429.57,60.84c-1.64-1.3-4,1-2.32,2.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M429,111.84l52.49-50.61c1.51-1.47-.8-3.78-2.32-2.31l-52.48,50.61c-1.52,1.46.79,3.77,2.31,2.31Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 334.28,
    y: 14.12,
    width: 243.06,
    height: 35.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 92.07,
    y: 14.12,
    width: 243.06,
    height: 35.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "335.56 14.12 334.71 14.12 92.49 14.12 92.49 49.27 334.71 49.27 335.56 49.27 577.77 49.27 577.77 14.12 335.56 14.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M128.11,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,128.11,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "557.2 25.82 551.64 12.49 562.41 12.49 562.41 25.82 557.2 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "543.28 25.82 537.72 12.49 548.49 12.49 548.49 25.82 543.28 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "518.69 25.82 513.12 12.49 523.89 12.49 523.89 25.82 518.69 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "504.77 25.82 499.21 12.49 509.97 12.49 509.97 25.82 504.77 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "478.42 25.82 472.86 12.49 483.62 12.49 483.62 25.82 478.42 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "464.5 25.82 458.94 12.49 469.71 12.49 469.71 25.82 464.5 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "438.15 25.82 432.59 12.49 443.36 12.49 443.36 25.82 438.15 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "424.23 25.82 418.67 12.49 429.44 12.49 429.44 25.82 424.23 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "399.64 25.82 394.07 12.49 404.84 12.49 404.84 25.82 399.64 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "385.72 25.82 380.16 12.49 390.92 12.49 390.92 25.82 385.72 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "359.37 25.82 353.81 12.49 364.57 12.49 364.57 25.82 359.37 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "345.45 25.82 339.89 12.49 350.66 12.49 350.66 25.82 345.45 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "318.75 25.82 313.19 12.49 323.96 12.49 323.96 25.82 318.75 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "304.83 25.82 299.27 12.49 310.04 12.49 310.04 25.82 304.83 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "278.13 25.82 272.57 12.49 283.34 12.49 283.34 25.82 278.13 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "264.22 25.82 258.65 12.49 269.42 12.49 269.42 25.82 264.22 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "238.92 25.82 233.36 12.49 244.12 12.49 244.12 25.82 238.92 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "225 25.82 219.44 12.49 230.21 12.49 230.21 25.82 225 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "199 25.82 193.44 12.49 204.21 12.49 204.21 25.82 199 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "185.08 25.82 179.52 12.49 190.29 12.49 190.29 25.82 185.08 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "158.74 25.82 153.17 12.49 163.94 12.49 163.94 25.82 158.74 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "144.82 25.82 139.25 12.49 150.02 12.49 150.02 25.82 144.82 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "118.47 25.82 112.91 12.49 123.67 12.49 123.67 25.82 118.47 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "104.55 25.82 98.99 12.49 109.75 12.49 109.75 25.82 104.55 25.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M113.58,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,113.58,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M119-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M104.44-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M168.41,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,168.41,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M153.88,13.26A5.87,5.87,0,1,1,148,7.39,5.87,5.87,0,0,1,153.88,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M159.27-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M144.74-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M208.59,13.26a5.88,5.88,0,1,1-5.87-5.87A5.87,5.87,0,0,1,208.59,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M194.05,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,194.05,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M199.45-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M184.91-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M248.88,13.26A5.87,5.87,0,1,1,243,7.39,5.87,5.87,0,0,1,248.88,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M234.35,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,234.35,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M239.74-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M225.21-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 282.27,
    cy: 25.83,
    r: 5.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M273.61,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,273.61,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M279-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M264.47-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M328.44,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,328.44,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 308.04,
    cy: 25.83,
    r: 5.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M319.3-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M304.77-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M368.62,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,368.62,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M354.08,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,354.08,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M359.48-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M344.94-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M408.91,13.26A5.87,5.87,0,1,1,403,7.39,5.87,5.87,0,0,1,408.91,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M394.38,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,394.38,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M399.77-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M385.24-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M448.18,13.26a5.88,5.88,0,1,1-5.88-5.87A5.87,5.87,0,0,1,448.18,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M433.64,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,433.64,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M439-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M424.5-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M488.47,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,488.47,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M473.94,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,473.94,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M479.33-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M464.8-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M528.65,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,528.65,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M514.11,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,514.11,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M519.51-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M505-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M568.94,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,568.94,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M554.41,13.26a5.87,5.87,0,1,1-5.87-5.87A5.87,5.87,0,0,1,554.41,13.26Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M559.8-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M545.27-9.41v21c0,4.21,6.54,4.21,6.54,0v-21c0-4.2-6.54-4.21-6.54,0Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 92.07,
    y: 50.65,
    width: 485.28,
    height: 10.99
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.63,364.69c-1.05-18.38-10.77-21.8-10.77-21s.53,13.39.53,13.39l.35,4c-.1.89-.21,1.82-.35,2.77a50.1,50.1,0,0,1-1.31,6.28c-.29,1-.63,2-1,3s-.8,1.91-1.24,2.81c-.23.44-.49.85-.71,1.29l-.74,1.22c-.53.78-1,1.52-1.56,2.18-.24.35-.52.65-.77,1s-.48.6-.72.86c-.49.51-.89,1-1.27,1.39-.74.74-1.17,1.23-1.17,1.23S319.68,383.07,318.63,364.69Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M303.57,407.58A1.57,1.57,0,1,1,302,406,1.57,1.57,0,0,1,303.57,407.58Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 414.38,
    cy: 323.72,
    r: 22.76,
    transform: "translate(-23.93 45.78) rotate(-4.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M393.5,380.86a10.76,10.76,0,1,1-6.73-13.66A10.75,10.75,0,0,1,393.5,380.86Z",
    transform: "translate(0 12.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 416.79,
    cy: 367.47,
    r: 8.16,
    transform: "translate(-136.04 324.1) rotate(-35.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M576.9,239.53a38.66,38.66,0,0,1-38.66,38.66H131.6A38.65,38.65,0,0,1,93,239.53V40.16A38.65,38.65,0,0,1,131.6,1.5H541A35.92,35.92,0,0,1,576.9,37.41Z",
    transform: "translate(0 12.56)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.0e300bb1eb6ffda901f429eac9419df7.svg";
export { ForwardRef as ReactComponent };